import React from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import ROUTES from "../../utils/routes.js";
import BaseTextButton from "../BaseTextButton";
import useAuth from "../../hooks/useAuth";

// 23.10: поддержка только для вошедших пользователей, гостю кнопку не показываем
// (она стоит на страницах входа и регистрации)
function SupportButton() {
  const { t } = useTranslation();
  const { token } = useAuth();
  if (!token) return null;
  return (
    <div className="support-btn-wrapper">
      <BaseTextButton to={ROUTES.SUPPORT_PAGE} className="btn-support">
        {t("support_btn")}
      </BaseTextButton>
    </div>
  );
}

export default SupportButton;
